export const FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID = '[DATA-COLLECTOR]FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID';
export const FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID_SUCCESS =
    '[DATA-COLLECTOR]FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID_SUCCESS';
export const FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID_FAILED =
    '[DATA-COLLECTOR]FETCH_DATA_COLLECTOR_BY_WORKSPACE_ID_FAILED';

export const FETCH_DATA_USAGE = '[DATA-COLLECTOR]FETCH_DATA_USAGE';
export const FETCH_DATA_USAGE_FAILED = '[DATA-COLLECTOR]FETCH_DATA_USAGE_FAILED';
export const FETCH_DATA_USAGE_SUCCESS = '[DATA-COLLECTOR]FETCH_DATA_USAGE_SUCCESS';
